module.exports = __webpack_public_path__ + "media/images/amenities_icons/bosu_ball_chairs-a1a591ea4d176ced147f8519abd6986b.svg";